<!--
  template(if) - list(show) 구조는 불필요한 로드를 방지하기 위해서임.
  refresh 는 add, edit 성공시 호출해야 함.
-->

<template>
  <div class="animated fadeIn">
    <template v-if="base">
    <ListQna v-show="list_qna" ref="list_qna" />
    <ListFaq v-show="list_faq" ref="list_faq" />
    <ListNotice v-show="list_notice" ref="list_notice" />
    </template>
  </div>
</template>

<script>
import ListQna from '../qna/QNA.List';
import ListFaq from '../faq/FAQ.List';
import ListNotice from '../notice/Notice.List';

export default {
  components: { ListQna, ListFaq, ListNotice },
  data: () => ({ base: true, list_qna: false, list_faq: false, list_notice: false }),
  methods: {
    refresh() { if(this.$refs.list) { this.$refs.list.refresh(); } },
    select({ id, tag }) {
      this.list_qna = this.list_faq = this.list_notice = true;
    }
  },
  watch: {
    '$route' (to, from) {
      console.log('board.main.vue', 'route changed', to.param);
      this.select(to.params);
    }
  },
  created() { console.log('board.main.vue', 'created'); },
  destroyed() { console.log('board.main.vue', 'destroyed'); },
  mounted() { console.log('board.main.vue', 'mounted'); this.select(this.$route.params); },
}
</script>
